// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/fonts/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/fonts/Gilroy-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../assets/fonts/Gilroy-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../assets/fonts/Gilroy-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_primary-surface__hVNa4 {
  background: #5d2de1;
  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24), 0px 2px 4px -1px rgba(27, 10, 82, 0.12), 0px 8px 8px -4px rgba(235, 79, 37, 0.12);
  border-radius: 12px;
}

.Modal_primary-bg__aq5Qu {
  background: #5d2de1;
  border-radius: 12px;
}

.Modal_secondary-surface__SJasR {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);
  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06), -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);
}

.Modal_faded-surface__X9SCF {
  background: rgba(93, 45, 225, 0.06);
  border-radius: 12px;
}

.Modal_header-surface__7rOqC {
  background: #5d2de1;
  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24), 0px 2px 4px -1px rgba(27, 10, 82, 0.12), 0px 8px 8px -4px rgba(235, 79, 37, 0.12);
  border-radius: 12px;
}

.Modal_card-surface__NIySq {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);
  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06), -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);
}

.Modal_dropdown-surface__Rp0A4 {
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);
  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06), -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);
  border-radius: 12px;
}

.Modal_faded-1-surface__ZQbLj {
  background: rgba(93, 45, 225, 0.06);
  mix-blend-mode: normal;
  border-radius: 12px;
}

.Modal_faded-2-surface__s2QzX {
  background: rgba(60, 53, 210, 0.12);
  mix-blend-mode: normal;
  border-radius: 12px;
}

@font-face {
  font-family: "bold-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "bold-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "semi-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "semi-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "med-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "bold-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: "extra-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: "semi-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.Modal_sectionTitle__bMqaj {
  color: rgba(20, 16, 41, 0.8);
  font-family: "bold-Poppins";
  font-weight: 700;
  font-size: 36px;
  line-height: 36px;
  position: relative;
}

.Modal_lightSectionTitle__Zt3Tx {
  color: #ffffff;
  font-family: "bold-Poppins";
  font-weight: 700;
  font-size: 36px;
  line-height: 36px;
}

.Modal_cardTitle__PXT\\+0 {
  color: rgba(20, 16, 41, 0.8);
  font-family: "semi-Montserrat";
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  display: block;
}

.Modal_cardSubTitle__vT2Vy {
  color: rgba(20, 16, 41, 0.8);
  font-family: "med-Montserrat";
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  display: block;
}

@font-face {
  font-family: "bold-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "bold-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "semi-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "semi-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "med-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "bold-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: "extra-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: "semi-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.Modal_popup-surface__V5DEA {
  position: fixed;
  left: 50%;
  transition: all 0.2s;
  z-index: 10;
  overflow: auto;
  max-height: 87vh;
  max-width: 100%;
  transform: translateX(-50%);
  border-radius: 12px;
}
@media (max-width: 550px) {
  .Modal_popup-surface__V5DEA {
    border-radius: 40px 40px 0px 0px;
  }
}

.Modal_show__49kNP {
  animation: Modal_fadeIn__w2\\+8F 0.3s forwards;
}
@media (max-width: 550px) {
  .Modal_show__49kNP {
    animation: Modal_resposiveFadeIn__83vAx 0.3s forwards;
  }
}

@keyframes Modal_fadeIn__w2\\+8F {
  0% {
    opacity: 0;
    top: 4%;
  }
  50% {
    opacity: 1;
    top: 12%;
  }
  100% {
    top: 10%;
  }
}
@keyframes Modal_resposiveFadeIn__83vAx {
  0% {
    opacity: 0;
    bottom: -105%;
  }
  100% {
    opacity: 1;
    bottom: 0;
  }
}
/* width */
.Modal_popup-surface__V5DEA::-webkit-scrollbar {
  width: 12px;
}

.Modal_popup-surface__V5DEA::-webkit-scrollbar-track {
  margin: 30px 0;
}

.Modal_popup-surface__V5DEA::-webkit-scrollbar-thumb {
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 9999px;
  background-color: #aaaaaa;
}`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/shared/_surface.scss","webpack://./src/components/UI/Modal/Modal.module.scss","webpack://./src/assets/stylesheets/_variables.scss","webpack://./src/assets/stylesheets/shared/_typography.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kIAAA;EAGA,mBAAA;ACDF;;ADGA;EACE,mBAAA;EACA,mBAAA;ACAF;;ADEA;EACE,6EAAA;EACA,yHAAA;ACCF;;ADEA;EACE,mCAAA;EACA,mBAAA;ACCF;;ADCA;EACE,mBAAA;EACA,kIAAA;EAGA,mBAAA;ACAF;;ADEA;EACE,6EAAA;EACA,yHAAA;ACCF;;ADEA;EACE,6EAAA;EACA,yHAAA;EAEA,mBAAA;ACAF;;ADOA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;ACJF;;ADMA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;ACHF;;ACJA;EACE,2BAAA;EACA,4CAAA;ADOF;ACLA;EACE,8BAAA;EACA,4CAAA;ADOF;ACLA;EACE,2BAAA;EACA,4CAAA;ADOF;ACLA;EACE,8BAAA;EACA,4CAAA;ADOF;ACLA;EACE,0BAAA;EACA,4CAAA;ADOF;ACLA;EACE,6BAAA;EACA,4CAAA;ADOF;ACLA;EACE,0BAAA;EACA,4CAAA;ADOF;ACLA;EACE,2BAAA;EACA,4CAAA;ADOF;ACLA;EACE,0BAAA;EACA,4CAAA;ADOF;ACLA;EACE,yBAAA;EACA,4CAAA;ADOF;AEvFA;EACE,4BDCgB;ECAhB,2BDiFuB;EChFvB,gBDoCU;ECnCV,eDoBc;ECnBd,iBD4BgB;EC3BhB,kBAAA;AFyFF;;AEvFA;EACE,cDNY;ECOZ,2BDyEuB;ECxEvB,gBD4BU;EC3BV,eDYc;ECXd,iBDoBgB;ADsElB;;AExFA;EACE,4BDdgB;ECehB,8BDsEsB;ECrEtB,gBDoBS;ECnBT,eAAA;EACA,iBDSe;ECRf,cAAA;AF2FF;;AEzFA;EACE,4BDtBgB;ECuBhB,6BD+DqB;EC9DrB,gBDWW;ECVX,eDVa;ECWb,iBDDe;ECEf,cAAA;AF4FF;;AC/EA;EACE,2BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,8BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,2BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,8BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,0BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,6BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,0BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,2BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,0BAAA;EACA,4CAAA;ADkFF;AChFA;EACE,yBAAA;EACA,4CAAA;ADkFF;AAhKA;EACE,eAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AAkKF;AAjKE;EAVF;IAWI,gCAAA;EAoKF;AACF;;AAjKA;EACE,6CAAA;AAoKF;AAnKE;EAFF;IAGI,qDAAA;EAsKF;AACF;;AAnKA;EACE;IACE,UAAA;IACA,OAAA;EAsKF;EApKA;IACE,UAAA;IACA,QAAA;EAsKF;EApKA;IACE,QAAA;EAsKF;AACF;AApKA;EACE;IACE,UAAA;IACA,aAAA;EAsKF;EApKA;IACE,UAAA;IACA,SAAA;EAsKF;AACF;AApKA,UAAA;AACA;EACE,WAAA;AAsKF;;AApKA;EACE,cAAA;AAuKF;;AApKA;EACE,kCAAA;EACA,4BAAA;EACA,qBAAA;EACA,yBAAA;AAuKF","sourcesContent":[".primary-surface {\n  background: #5d2de1;\n  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24),\n    0px 2px 4px -1px rgba(27, 10, 82, 0.12),\n    0px 8px 8px -4px rgba(235, 79, 37, 0.12);\n  border-radius: 12px;\n}\n.primary-bg {\n  background: #5d2de1;\n  border-radius: 12px;\n}\n.secondary-surface {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n    -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n}\n.faded-surface {\n  background: rgba(93, 45, 225, 0.06);\n  border-radius: 12px;\n}\n.header-surface {\n  background: #5d2de1;\n  box-shadow: 0px 0px 1px rgba(235, 79, 37, 0.24),\n    0px 2px 4px -1px rgba(27, 10, 82, 0.12),\n    0px 8px 8px -4px rgba(235, 79, 37, 0.12);\n  border-radius: 12px;\n}\n.card-surface {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n    -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n}\n.dropdown-surface {\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n  box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n    -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n  border-radius: 12px;\n}\n// .popup-surface {\n//   background: linear-gradient(135deg, #ffffff 0%, #fafbfc 51.82%, #f5f7fa 100%);\n//   box-shadow: 0px 1px 1px rgba(9, 13, 20, 0.06),\n//     -4px -4px 8px rgba(255, 255, 255, 0.4), 8px 8px 24px rgba(9, 13, 20, 0.06);\n// }\n.faded-1-surface {\n  background: rgba(93, 45, 225, 0.06);\n  mix-blend-mode: normal;\n  border-radius: 12px;\n}\n.faded-2-surface {\n  background: rgba(60, 53, 210, 0.12);\n  mix-blend-mode: normal;\n  border-radius: 12px;\n}\n","@use \"/src/assets/stylesheets/shared/surface\";\n@use \"/src/assets/stylesheets/shared/typography\";\n@import \"/src/assets/stylesheets/variables\";\n\n.popup-surface {\n  position: fixed;\n  left: 50%;\n  transition: all 0.2s;\n  z-index: 10;\n  overflow: auto;\n  max-height: 87vh;\n  max-width: 100%;\n  transform: translateX(-50%);\n  border-radius: 12px;\n  @media (max-width: 550px) {\n    border-radius: 40px 40px 0px 0px;\n  }\n}\n\n.show {\n  animation: fadeIn 0.3s forwards;\n  @media (max-width: 550px) {\n    animation: resposiveFadeIn 0.3s forwards;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    top: 4%;\n  }\n  50% {\n    opacity: 1;\n    top: 12%;\n  }\n  100% {\n    top: 10%;\n  }\n}\n@keyframes resposiveFadeIn {\n  0% {\n    opacity: 0;\n    bottom: -105%;\n  }\n  100% {\n    opacity: 1;\n    bottom: 0;\n  }\n}\n/* width */\n.popup-surface::-webkit-scrollbar {\n  width: 12px;\n}\n.popup-surface::-webkit-scrollbar-track {\n  margin: 30px 0;\n}\n\n.popup-surface::-webkit-scrollbar-thumb {\n  border: 4px solid rgba(0, 0, 0, 0);\n  background-clip: padding-box;\n  border-radius: 9999px;\n  background-color: #aaaaaa;\n}\n","// colors\n$primary-color: #5d2de1;\n$dark-color: #141029;\n$cultured-color: #f5f7fa;\n$dark-text-color: rgba(20, 16, 41, 0.8);\n$white-color: #ffffff;\n$card-gradient-color: linear-gradient(\n  135deg,\n  #ffffff 0%,\n  #fafbfc 51.82%,\n  #f5f7fa 100%\n);\n$pink-color: #e0e0ff;\n$white-color-40: rgba(255, 255, 255, 0.4);\n$white-color-4: rgba(224, 224, 255, 0.04);\n$danger-color: #f54562;\n\n// fonts\n\n$font-size-xs: 13px;\n$font-size-sm: 14px;\n$font-size-md: 16px;\n$font-size-xm: 18px;\n$font-size-lg: 20px;\n$font-size-xl: 24px;\n$font-size-xxl: 30px;\n$font-size-3xl: 36px;\n$font-size-4xl: 48px;\n\n$font-height-xs: 16px;\n$font-height-sm: 20px;\n$font-height-md: 24px;\n$font-height-xm: 28px;\n$font-height-lg: 30px;\n$font-height-xl: 32px;\n$font-height-xxl: 36px;\n$font-height-3xl: 40px;\n$font-height-4xl: 48px;\n\n$font-light: 500;\n$font-med: 600;\n$font-bold: 700;\n$font-extra: 800;\n\n@font-face {\n  font-family: \"bold-Poppins\";\n  src: url(/assets/fonts/Poppins-Bold.ttf);\n}\n@font-face {\n  font-family: \"bold-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Bold.ttf);\n}\n@font-face {\n  font-family: \"semi-Poppins\";\n  src: url(/assets/fonts/Poppins-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"semi-Montserrat\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-Poppins\";\n  src: url(/assets/fonts/Poppins-Medium.ttf);\n}\n@font-face {\n  font-family: \"med-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Medium.ttf);\n}\n@font-face {\n  font-family: \"bold-gilory\";\n  src: url(/assets/fonts/Gilroy-Bold.ttf);\n}\n@font-face {\n  font-family: \"extra-gilory\";\n  src: url(/assets/fonts/Gilroy-ExtraBold.otf);\n}\n@font-face {\n  font-family: \"semi-gilory\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-gilory\";\n  src: url(/assets/fonts/Gilroy-Medium.ttf);\n}\n\n$title-font-family-bold: \"bold-Poppins\";\n$title-font-family-semi: \"semi-Poppins\";\n$title-font-family-med: \"med-Poppins\";\n$text-font-family-bold: \"bold-Montserrat\";\n$text-font-family-semi: \"semi-Montserrat\";\n$text-font-family-med: \"med-Montserrat\";\n$number-font-family-bold: \"bold-gilory\";\n$number-font-family-extra: \"extra-gilory\";\n$number-font-family-semi: \"semi-gilory\";\n$number-font-family-med: \"med-gilory\";\n\n// dark and light theme\n$dark-bg-color: #111315; // background\n$dark-sb-bg-color: #242527; // sidebar\n\n$light-bg-color: #F4F4F4; // background\n$light-sb-bg-color: #FCFCFC; // sidebar","@import \"../variables\";\n\n.sectionTitle {\n  color: $dark-text-color;\n  font-family: $title-font-family-bold;\n  font-weight: $font-bold;\n  font-size: $font-size-3xl;\n  line-height: $font-height-xxl;\n  position: relative;\n}\n.lightSectionTitle {\n  color: $white-color;\n  font-family: $title-font-family-bold;\n  font-weight: $font-bold;\n  font-size: $font-size-3xl;\n  line-height: $font-height-xxl;\n}\n.cardTitle {\n  color: $dark-text-color;\n  font-family: $text-font-family-semi;\n  font-weight: $font-med;\n  font-size: $font-size-md;\n  line-height: $font-height-md;\n  display: block;\n}\n.cardSubTitle {\n  color: $dark-text-color;\n  font-family: $text-font-family-med;\n  font-weight: $font-light;\n  font-size: $font-size-xs;\n  line-height: $font-height-xs;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-surface": `Modal_primary-surface__hVNa4`,
	"primary-bg": `Modal_primary-bg__aq5Qu`,
	"secondary-surface": `Modal_secondary-surface__SJasR`,
	"faded-surface": `Modal_faded-surface__X9SCF`,
	"header-surface": `Modal_header-surface__7rOqC`,
	"card-surface": `Modal_card-surface__NIySq`,
	"dropdown-surface": `Modal_dropdown-surface__Rp0A4`,
	"faded-1-surface": `Modal_faded-1-surface__ZQbLj`,
	"faded-2-surface": `Modal_faded-2-surface__s2QzX`,
	"sectionTitle": `Modal_sectionTitle__bMqaj`,
	"lightSectionTitle": `Modal_lightSectionTitle__Zt3Tx`,
	"cardTitle": `Modal_cardTitle__PXT+0`,
	"cardSubTitle": `Modal_cardSubTitle__vT2Vy`,
	"popup-surface": `Modal_popup-surface__V5DEA`,
	"show": `Modal_show__49kNP`,
	"fadeIn": `Modal_fadeIn__w2+8F`,
	"resposiveFadeIn": `Modal_resposiveFadeIn__83vAx`
};
export default ___CSS_LOADER_EXPORT___;
